import { TFunction } from 'react-i18next';
import * as yup from 'yup';

export const CreateForm = (t: TFunction): yup.ObjectSchema<any> =>
  yup.object({
    name: yup.string().required(t('form-schemas.venue-name-is-required')),
    code: yup
      .string()
      .required(t('form-schemas.venue-code-is-required'))
      .min(6, t('form-schemas.venue-code-min-characters')),
    controllerIp: yup.string().required(t('form-schemas.ip-controller-is-required')),
    countryCode: yup.string().required(t('form-schemas.country-code-is-required')),
    controllerUser: yup.string().required(t('form-schemas.user-controller-is-required')),
    controllerPassword: yup.string().required(t('form-schemas.password-controller-is-required')),
    language: yup.string().required(t('form-schemas.ip-controller-is-required')),
    useApuestaTotal: yup.boolean().required(t('form-schemas.apuesta-total-is-required')),
    hideFrame: yup.boolean().required(t('form-schemas.hide-splash-frame-is-required')),
    promotionVideoUrl: yup.mixed().when('hasPromotionVideo', {
      is: true,
      then: yup
        .string()
        .required(t('form-schemas.url-video-is-required'))
        .test('no-spaces', t('form-schemas.url-video-without-spaces'), (value) => {
          if (value) {
            return !/\s/.test(value);
          }
          return true;
        }),
    }),
    logoSubtitle: yup.mixed().when('hasDiferentLogoLayout', {
      is: true,
      then: yup
        .string()
        .required(t('form-schemas.subtitle-logo-is-required'))
        .max(50, t('form-schemas.subtitle-logo-max-50-characters')),
    }),
  });
